import { FeedbackEnvironmentEnum } from '@jfw/types';

// Replaced at build time by the pipeline's `ng build --define BUILD_SHA=...`
// (bitbucket-pipelines.yml, jfw-platform-portal step). Absent in local builds
// and in jest, hence the typeof guard below.
declare const BUILD_SHA: string | undefined;

export function getBuildVersion(): string {
  const sha = typeof BUILD_SHA === 'string' ? BUILD_SHA.trim() : '';
  return sha ? sha.slice(0, 9) : 'local';
}

export function toFeedbackEnvironment(
  envVersion: string,
): FeedbackEnvironmentEnum {
  switch (envVersion) {
    case 'prod':
      return FeedbackEnvironmentEnum.Prod;
    case 'test':
      return FeedbackEnvironmentEnum.Test;
    case 'dev':
      return FeedbackEnvironmentEnum.Dev;
    default:
      return FeedbackEnvironmentEnum.Local;
  }
}

/** Drops the query string and fragment -- they can carry search terms or
 * tokens, and the path alone is enough to identify the failing call. */
export function stripQuery(url: string): string {
  return url.split(/[?#]/)[0];
}

export function parseBrowser(userAgent: string): {
  name: string;
  version: string;
} {
  // Order matters: Edge and Opera also carry "Chrome/", and Chrome carries
  // "Safari/".
  const matchers: Array<[string, RegExp]> = [
    ['Edge', /Edg\/(\d+)/],
    ['Opera', /OPR\/(\d+)/],
    ['Firefox', /Firefox\/(\d+)/],
    ['Chrome', /Chrome\/(\d+)/],
    ['Safari', /Version\/(\d+).*Safari/],
  ];
  for (const [name, pattern] of matchers) {
    const match = userAgent.match(pattern);
    if (match) {
      return { name, version: match[1] };
    }
  }
  return { name: 'Unknown', version: '' };
}

export function parseOs(userAgent: string): string {
  if (/Windows/.test(userAgent)) return 'Windows';
  if (/iPhone|iPad|iPod/.test(userAgent)) return 'iOS';
  if (/Mac OS X/.test(userAgent)) return 'macOS';
  if (/Android/.test(userAgent)) return 'Android';
  if (/CrOS/.test(userAgent)) return 'ChromeOS';
  if (/Linux/.test(userAgent)) return 'Linux';
  return 'Unknown';
}

export function errorMessageOf(error: unknown): string {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : String((error as { message?: unknown })?.message ?? 'Unknown error');
  // Message only -- never the stack, which can run to kilobytes.
  return message.slice(0, 1000);
}
